import type { Resource } from '../../';
export const cart_couponCodes_rejection_alreadyApplied: Resource = {"default":"This coupon has already been added to the bag."};
